import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  TEAM_ENUM
} from './constants'
import {
  entitiesSelector,
} from 'helpers/ComponentSelectorUtil'

const productRolesRefs = state => state.product.productSupportTeam
const productRolesChanges = state => state.product.productSupportTeamChanges
const productRolesValues = state => {
  const productRoles = entitiesSelector(state)['product_roles']
  return productRoles ? productRoles : []
}

const productIdSelector = state => state.product.view.detailId
const editSelector = state => state.product.edit

const productRolesSelector = createSelector(
  productRolesValues,
  productRolesRefs,
  (values, refs) => refs.map(id => values[id])
)

const filterByRole = R.propEq('role')
const byPae = filterByRole(TEAM_ENUM.PRODUCT_APPLICATIONS_ENGINEER)
const byPm = filterByRole(TEAM_ENUM.PRODUCT_MANAGER)
const bySpm = filterByRole(TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER)
const byAed = filterByRole(TEAM_ENUM.APPLICATIONS_ENGINEERING_DIRECTOR)

const pmSelector = createSelector(
  productRolesChanges,
  R.filter(byPm)
)

const paeSelector = createSelector(
  productRolesChanges,
  R.filter(byPae)
)

const spmSelector = createSelector(
  productRolesChanges,
  R.filter(bySpm)
)

const aedSelector = createSelector(
  productRolesChanges,
  R.filter(byAed)
)



export {
  pmSelector,
  paeSelector,
  spmSelector,
  aedSelector,
  productRolesSelector,
  productRolesChanges,
  productIdSelector,
  editSelector
}
